import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import { logger } from '../utils/logger';

interface PrivateRouteProps {
  children: React.ReactNode;
}

const PrivateRoute = ({ children }: PrivateRouteProps) => {
  const { isAuthenticated, token } = useAuthStore();

  if (!isAuthenticated || !token) {
    logger.warn('Unauthorized access attempt, redirecting to login');
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export default PrivateRoute;
